














































































































import { Component, Vue } from 'vue-property-decorator';
import { pcService } from '../services/pc.service';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { utilsService } from '../services/utils.service';
import { switchMap } from 'rxjs/operators';
import { userService } from '../services/user.service';
import { dvService } from '@/services/device.service';
import { of } from 'rxjs';
import Music from '@/components/Music.vue';
@Component({
  components: { swiper, swiperSlide, Music },
  // computed: {}
})
export default class Home extends Vue {
  isPlay: boolean = !this.$store.state.audios.bgm.muted; //音乐是否播放
  activeIndex: number = 1;
  swiperLen: number = 3; //轮播个数
  days: number = 0; //剩余天数
  countdown: string = '00:12:13'; //首页轮播倒计时时间
  endTime: number = new Date('2020/8/26 22:00:00').getTime();
  // endTime: number = new Date('2020/8/25 18:21:00').getTime();
  swiperOptions: any = {
    autoplay: 3000,
    pagination: '.swiper-pagination',
  };
  isWx: boolean = dvService.isWX;
  replace: boolean = window.history.length === 1;
  pop() {
    pcService.confirm$.next({ isOpen: true, data: { type: 'alert' } });
  }

  get missions() {
    return this.$store.state.missions;
  }

  get allcheck() {
    return this.$store.state.allcheck;
  }

  get every_chapter_prize_num() {
    return this.$store.state.every_chapter_prize_num;
  }

  get score() {
    return this.$store.getters.score;
  }

  get gameProgress() {
    return this.$store.getters.gameProgress;
  }

  get aheadNum() {
    if (this.score.total === 0) return 0;
    const num = Math.floor(this.score.total / 60e3);
    const fields = [99, 98, 97, 90, 88, 85, 80, 78, 70, 66, 37];
    return fields[num] || 37;
  }

  get times() {
    return this.$store.state.times;
  }

  get version() {
    return this.$store.getters.version;
  }
  toggleMusic() {
    this.isPlay = !this.isPlay;
    this.$store.state.audios.bgm.muted = !this.isPlay;
  }

  ms2Str(time: number) {
    return utilsService.ms2Str(time);
  }

  goWinlist() {
    this.$router.replace('/winlist/');
  }
  countTime(end: number, now: number) {
    var differTime = end - now;
    var h, m, s;
    if (differTime >= 0) {
      h = Math.floor(differTime / 1000 / 60 / 60);
      m = Math.floor((differTime / 1000 / 60) % 60);
      s = Math.floor((differTime / 1000) % 60);
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      this.countdown = h + ':' + m + ':' + s;
      setTimeout(() => {
        this.countTime(end, now + 1000);
      }, 1000);
    } else {
      this.countdown = '00:00:00';
    }
  }
  goDetail(num) {
    let path = '/kvDetail/' + num;
    if (num == 1) {
      utilsService.gaEvent('home', 'kv', 'countdown');
    } else if (num == 2) {
      utilsService.gaEvent('home', 'kv', 'model');
    } else {
      utilsService.gaEvent('home', 'kv', 'krypton');
    }

    if (num == 2 && this.gameProgress < 2) {
      // 完成通关“秘境逃脱”<br>方可解锁“隐匿之钥
      pcService.confirm$.next({
        isOpen: true,
        data: {
          type: 'alert',
          alertHtml: '完成通关“秘境逃脱”<br>方可解锁“隐匿之钥”',
          isShow: true,
        },
      });
      return;
    }

    if (this.replace) {
      this.$router.replace(path);
    } else {
      this.$router.push(path);
    }
  }
  gaEv(path: string) {
    if (path.indexOf('maze') > 0) {
      // console.log('maze');
      utilsService.gaEvent('home', 'mission1', 'maze');
    } else if (path.indexOf('cube') > 0) {
      // console.log('cube');
      utilsService.gaEvent('home', 'mission1', 'cube');
    } else if (path.indexOf('graphical') > 0) {
      // console.log('graphical');
      utilsService.gaEvent('home', 'mission2', 'graphical');
    } else if (path.indexOf('sudoku') > 0) {
      // console.log('sudoku');
      utilsService.gaEvent('home', 'mission2', 'sudoku');
    } else {
      // console.log('book');
      utilsService.gaEvent('home', 'mission3', 'book');
    }
  }
  computed() {
    return (this.$refs.mySwiper as any).$swiper;
  }

  created() {}

  mounted() {
    // of(0)
    //   .pipe(
    //     switchMap(() => userService.initUserData()),
    //     switchMap(res => userService.mergeData(res)),
    //   )
    //   .subscribe(res => console.log('数据加载完成'));

    setTimeout(() => {
      this.$store.state.audios.bgm.play();
    }, 500);

    this.days = utilsService.getDays(this.endTime, this.times);
    if (this.days == 0) {
      this.countTime(this.endTime, Date.now());
    }
  }

  destroyed() {
    // this.$store.state.audios.bgm.pause();
  }
}
